import React from 'react'
import './Card.css'
import TableUtils from '../../utils/TableUtils'

class Card extends React.Component {
    render() {
		return (
            <div className="card-container">
                <div className="card-body">
                    <h4 style={{textAlign:"center",color:"#000"}}>Crédito</h4>
                    {this.props.infoCredito &&
                    <ul>
                        <li>Total: {TableUtils.numberFormat(this.props.infoCredito.total)}</li>
                        <li>Consumido: {TableUtils.numberFormat(this.props.infoCredito.consumido)}</li>
                        <li>Disponible: {TableUtils.numberFormat(this.props.infoCredito.disponible)}</li>
                    </ul>
                    }
                </div>
            </div>
        )
    }
}
export default Card


// WEBPACK FOOTER //
// ./src/components/card/Card.js